var r=t=>t?.toUpperCase();export{r as default};
